// src/App.tsx
import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

import { ReviewsProvider } from '@/context/reviews';
import { ThemeProvider } from './theme/ThemeProvider';

import { Canonicalize } from '@/utils/Canonicalize';
import LegacyHierRedirect from '@/utils/LegacyHierRedirect';
import LegacyFlatRedirect from '@/utils/LegacyFlatRedirect';

const HomePage = lazy(() => import('@/pages/HomePage'));
const TargetPage = lazy(() => import('@/pages/TargetPage'));

export default function App() {
  return (
    <ThemeProvider>
      <ReviewsProvider>
        <Canonicalize />
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/תקליטן/:type/" element={<TargetPage />} />
            <Route path="/תקליטן/:type/:location/" element={<TargetPage />} />
            <Route path="/:region/:city/תקליטן/*" element={<LegacyHierRedirect />} />
            <Route path="/:region/:city/תקליטן/:type/*" element={<LegacyHierRedirect />} />
            <Route path="/:region/תקליטן/*" element={<LegacyHierRedirect />} />
            <Route path="/תקליטן-:flatSlug/*" element={<LegacyFlatRedirect />} />
          </Routes>
        </Suspense>
      </ReviewsProvider>
    </ThemeProvider>
  );
}